// src/components/organism/AccountOverview/AccountUsers/AccountUsers.tsx
import React, { useMemo } from 'react';
import { Container, Row, Col, HeaderText } from 'shared-portal-component';

import AccountOverviewCard from '@/components/organism/AccountOverview/AccountOverviewCard/AccountOverviewCard';
import BarChart from '@/components/atoms/Chart/BarChart/BarChart';
import type { SeatBucket } from '@/types/organization.types';

interface Props {
  loading?: boolean;
  internalSeats?: SeatBucket;
  externalSeats?: SeatBucket;
}

const AccountUsers: React.FC<Props> = ({ loading, internalSeats, externalSeats }) => {
  const internalRow = useMemo(
    () => [
      {
        label: 'Internal',
        purchased: internalSeats?.available ?? 0,
        active: internalSeats?.active ?? 0,
        new: internalSeats?.new ?? 0,
        inactive: internalSeats?.inactive ?? 0,
      },
    ],
    [internalSeats]
  );

  const externalRow = useMemo(
    () => [
      {
        label: 'External',
        purchased: externalSeats?.available ?? 0,
        active: externalSeats?.active ?? 0,
        new: externalSeats?.new ?? 0,
        inactive: externalSeats?.inactive ?? 0,
      },
    ],
    [externalSeats]
  );

  return (
    <AccountOverviewCard title="Account Users" loading={loading}>
      <Container fluid>
        <Row spacing="md" className="mb-4">
          <Col size={12}>
            <HeaderText text="Internal User Seats" as="h3" size="h2" />
          </Col>
          <Col size={12}>
            <BarChart data={internalRow} variant="minimal" height={50} seatType="Internal" />
          </Col>
        </Row>

        <Row spacing="md">
          <Col size={12}>
            <HeaderText text="External User Seats" as="h3" size="h2" />
          </Col>
          <Col size={12}>
            <BarChart data={externalRow} variant="minimal" height={50} seatType="External" />
          </Col>
        </Row>
      </Container>
    </AccountOverviewCard>
  );
};

export default AccountUsers;
